import vanillaSmoothie from "vanilla-smoothie";

export default function scrollToTop() {
    vanillaSmoothie.scrollTop({ easing: 'easeOutQuad' });
}
